
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import 'bootstrap/dist/css/bootstrap.css';
import { Container, Image, Tab, Tabs } from "react-bootstrap";
import {castcoTitleIcon} from "../../assets/imgs";
import SteelBarFormModel from "../../models/SteelBarFormModel";
import ImageModel from "../../models/ImageModel";
import ImgUploadBox from "../../components/applicationForm/items/ImgUploadBox";
import SignatureValid from "../../function/SignatureValidation";
import SteelBarFormOfficialModel from "../../models/OfficialModel";
import useDeviceSize from "../../utils/useDeviceSize";
import api from '../../app/api/agent'
import { GlobalStateContext } from "../../store/GlobalState";
//import Cookies from "js-cookie";
import { toast } from "react-toastify";
import React from "react";

  const SteelBarFormView = () => {
    const navigate = useNavigate();
  
    const[SrcSignSteel, setSrcSignSteel] = useState("")
    const[SrcSignChemistry, setSrcSignChemistry] = useState("")
    const[SrcSign, setSrcSign] = useState("")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const[SrcChop, setSrcChop] = useState("")
    const[SrcStockistCert, setSrcStockistCert] = useState<string[]>([])
    const[SrcStockistCertType, setSrcStockistCertType] = useState<string[]>([])
    const[SrcMillCert, setSrcMillCert] = useState<string[]>([])
    const[SrcMillCertType, setSrcMillCertType] = useState<string[]>([])
    const [validated, setValidated] = useState(false);
    //const[Src, setSrc] = useState("")
    const[type, setType] = useState("")  

    const [steelBarFormOfficial, setSteelBarFormOfficial] = useState(new SteelBarFormOfficialModel())
    const [submitting, setsubmitting] = useState(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();
    const formId = searchParams.get("formId")

    const [SteelBarForm, setSteelBarForm] = useState<{ [x: string]: any } | undefined>(undefined)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [Spe, setSpe] = useState<{ [x: string]: any } | undefined>(undefined)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [TR, setTR] = useState<{ [x: string]: any } | undefined>(undefined)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [Official, setOfficial] = useState<{ [x: string]: any } | undefined>(undefined)

    //const contentToPrint = useRef(null);
    //const [dataUpdate, setUpdate] = useState(0);

    const submitButtonRef = useRef<HTMLButtonElement>(null);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [admin, setAdmin] = useState(false);
    //const [admin, setAdmin] = useState(true);
    const [steelBarFormData, setSteelBarFormData] = useState(new SteelBarFormModel())
    const [imgData, setImg] = useState(new ImageModel())
    const[SrcSignatureSteel, setSrcSignatureSteel] = useState("")
    const[SrcSignatureChemistry, setSrcSignatureChemistry] = useState("")

    useEffect(()=>{
        if(imgData.signatureSteel){
            setSrcSignatureSteel(URL.createObjectURL(imgData.signatureSteel))
        }else{
            setSrcSignatureSteel("")
        }
    },[imgData.signatureSteel]) 

    useEffect(()=>{
        if(imgData.signatureChemistry){
            setSrcSignatureChemistry(URL.createObjectURL(imgData.signatureChemistry))
        }else{
            setSrcSignatureChemistry("")
        }
    },[imgData.signatureChemistry])

    const getDetail = async(formId: string)=>{
        await api.get(`/SteelBarForm?formId=${formId}`,{withCredentials: true}).then((response)=>{
            if (response.status !== 404){
                setSteelBarForm(response.data)
            }else{
                setSteelBarForm([])
            }
        })
        /* await api.get(`/Admin/GetSteelBarFormRecord?formId=${formId}`).then((response)=>{
            if (response.status !== 404){
                setSteelBarForm(response.data)
            }else{
                setSteelBarForm([])
            }
        })
        await api.get(`/Admin/GetSteelBarFormSpecimensRecord?formId=${formId}`).then((response)=>{
            if (response.status !== 404){
                setSpe(response.data)
            }else{
                setSpe([])
            }
        })
        await api.get(`/Admin/GetSteelBarFormTestReportRecord?formId=${formId}`).then((response)=>{
            if (response.status !== 404){
                setTR(response.data)
            }else{
                setTR([])
            }
        })
        await api.get(`/Admin/GetSteelBarFormOfficialRecord?formId=${formId}`).then((response)=>{
            if (response.status !== 404){
                setOfficial(response.data)
            }else{
                setOfficial([])
            }
        }) */
    }

    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{
      
        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
            api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        if(formId){
            getDetail(formId)
            //getSrc("Signature", formId)
            if(!admin){
                //getSrc("Steel", formId)
                //getSrc("Chemistry", formId)
            }
            //getSrcType("Chop", formId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        
            if(SteelBarForm && SrcSign === ""){
                getSrc("Chop", SteelBarForm["chop"])
                getSrc("Sign", SteelBarForm["signature"])

                var list: string[] = [];
                for(var index = 0; index <= SteelBarForm.additionInfo.length - 1; index++){
                    list.push(SteelBarForm.additionInfo[index].stockistCert ?? "");
                }

                console.log(list)
                getSrcCert("StockistCert", list)


                list = [];
                for(index = 0; index <= SteelBarForm.additionInfo.length - 1; index++){
                    list.push(SteelBarForm.additionInfo[index].millCert ?? "");
                }

                console.log(list)
                getSrcCert("MillCert", list)

            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[SteelBarForm])

    useEffect(()=>{
        if(formId){
            //getSrc("Chop", formId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[type])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getSrcType = async(genre: string, formId: string)=>{
        var apiurl = "/File/GetImageFileType?formId=";
        await api.get(apiurl + formId + "&genre=" + genre).then(async (response) =>{
            if(response){
                setType(response.data);
            }
         })
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getSrcCert = async(genre: string, IdList: string[])=>{
    try{
        
        var SrcStockistCertList: string[] = []
        var SrcStockistCertListType: string[] = []
        var SrcMillCertList: string[] = []
        var SrcMillCertListType: string[] = []
        for (const Id of IdList) {
            if(Id === ""){
                if(genre==="StockistCert"){
                    SrcStockistCertList!.push("");
                    SrcStockistCertListType!.push("");

                }else{
                    
                    SrcMillCertList!.push("");
                    SrcMillCertListType!.push("");
                }
            }else{

            await api.get(localStorage.accessToken ? `/File/${genre}/${Id}/${localStorage.getItem("accessToken")}` : `/File/${genre}/${Id}`, {
                responseType: "arraybuffer",
                withCredentials: localStorage.accessToken ? false : true,
                }).then(async (response)=>{
                        const contentType = response.headers['content-type']?.toString();
                        const data = new Uint8Array(response.data);
                        var ext = ".zip";
                        if (data.length < 2) ext = 'unknown';
                        if (data[0] == 0xFF && data[1] == 0xD8) ext = '.jpg';
                        if (data[0] == 0x89 && data[1] == 0x50) ext = '.png';
                        if (data[0] == 0x50 && data[1] == 0x4B) ext = '.zip';
                        if (data[0] == 0x25 && data[1] == 0x50) ext = '.pdf';
                        if (contentType!.includes("pdf")){
                            //setSrc("");
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }else if(contentType!.includes("image")){
                            //setSrc("");
                            buffer = response.data;
                            blob = new Blob([buffer], {
                                type: 'image/png'
                            });
                            objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }else{
                            //setSrc("");
                            buffer = response.data;
                            blob = new Blob([buffer], {
                                type: 'application/octet-stream'
                            });
                            objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            if(genre==="StockistCert"){
                                SrcStockistCertList!.push(objectURL);
                                SrcStockistCertListType!.push(ext!);
                            }else{
                                SrcMillCertList!.push(objectURL);
                                SrcMillCertListType!.push(ext!);
                            }
                        }
                    }

                )
        
            }
        }
        if(genre==="StockistCert"){
            console.log(SrcStockistCertList)
            console.log(SrcStockistCertListType)
            setSrcStockistCert(SrcStockistCertList);  
            setSrcStockistCertType(SrcStockistCertListType);  
        }else{
            console.log(SrcMillCertList)
            console.log(SrcMillCertListType)
            setSrcMillCert(SrcMillCertList);  
            setSrcMillCertType(SrcMillCertListType);  
        }
    }catch(e){
    console.log(`Error: ${e}`)
    }
    
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getSrc = async(genre: string, Id: string)=>{
        try{
            //var apiurl = "/File/GetImageFile?formId=";
            //await api.get(apiurl + formId + "&genre=" + genre, {
            await api.get(localStorage.accessToken ? `/File/${genre}/${Id}/${localStorage.getItem("accessToken")}` : `/File/${genre}/${Id}`, {
                responseType: "arraybuffer",
                withCredentials: localStorage.accessToken ? false : true,
              }).then(async (response)=>{

                    const data = new Uint8Array(response.data);
                    var ext = "image";
                    if (data[0] == 0x25 && data[1] == 0x50) ext = 'pdf';

                    if(genre === "Steel" || genre === "Chemistry" || genre === "Sign"){
                        if(genre === "Steel"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSignSteel(base64)
                        }
                        else if(genre === "Chemistry"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSignChemistry(base64)
                        }
                        else{
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcSign(base64)
                        }
                    }else{
                        const contentType = response.headers['content-type']?.toString();
                        if (ext!.includes("pdf")){
                            //setSrc("");
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            setSrcChop(objectURL);
                            setType(ext!)
                        }else{
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcChop(base64)
                            setType(ext!)
                        }
                        /* else if (type === "Photo Not Found"){
                            //setSrc("");
                        }
                        else if (type !== "pdf"){
                            const base64 = btoa(
                                new Uint8Array(response.data).reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ''
                                )
                            )
                            //setSrc(base64)
                            setSrcChop(base64)
                        }else{
                            var buffer = response.data;
                            var blob = new Blob([buffer], {
                                type: 'application/pdf'
                            });
                            var objectURL = URL.createObjectURL(blob);
                            //setSrc(objectURL);
                            setSrcChop(objectURL);
                        } */
                    }

                    
            })
          }catch(e){
            console.log(`Error: ${e}`)
          }
        
        }
    var objectToFormData = function(obj: any, form: any, namespace: any) {
    
        var fd = form || new FormData();
        var formKey;
        
        for(var property in obj) {
          if(obj.hasOwnProperty(property)) {
            
            if(namespace) {
              formKey = namespace + '[' + property + ']';
            } else {
              formKey = property;
            }
           
            // if the property is an object, but not a File,
            // use recursivity.
            if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
              
              objectToFormData(obj[property], fd, property);
              
            } else {
              
              // if it's a string or a File object
              fd.set(formKey, obj[property]);
            }
            
          }
        }
        
        return fd;
          
      };

    const handleDataUpload = async () =>{
        var steelBarFormOfficialDto = {
            METHOD: steelBarFormOfficial.Method,
            CAPABILITY: steelBarFormOfficial.Capability,
            RESOURCES: steelBarFormOfficial.Resources,
            COMPLETION_DATE: steelBarFormOfficial.CompletionDate,
            SUBCONTRACTING: steelBarFormOfficial.Subcontracting,
            CONFLICT_OF_INTEREST: steelBarFormOfficial.ConflictOfInterest,
            ACCEPTED_BY: steelBarFormOfficial.AcceptedBy,
            DATE: steelBarFormOfficial.Date,
            SAMPLE_LOCATION: steelBarFormOfficial.SampleLocation,
            REMARKS: steelBarFormOfficial.Remarks,
            
            STEEL_LABORATORY_FEEDBACK: steelBarFormData.steelLaboratoryFeedback,
            CHEMISTRY_LABORATORY_FEEDBACK: steelBarFormData.chemistryLaboratoryFeedback,
        }
        var ImgDataChopAndSignature = {
            ChopGenre: imgData.ChopGenre,
            ChopImgForm: imgData.Chop,
            ChopDocType: imgData.ChopDocType,
            SignatureGenre: imgData.SignatureGenre,
            SignatureImgForm: imgData.signature,
            SignatureDocType: imgData.SignatureDocType,
            SignatureGenreSteel: imgData.SignatureGenreSteel,
            SignatureImgFormSteel: imgData.signatureSteel,
            SignatureDocTypeSteel: imgData.SignatureDocTypeSteel,
            SignatureGenreChemistry: imgData.SignatureGenreChemistry,
            SignatureImgFormChemistry: imgData.signatureChemistry,
            SignatureDocTypeChemistry: imgData.SignatureDocTypeChemistry,
        }
        var formdata = new FormData();
        objectToFormData(ImgDataChopAndSignature, formdata, "");
        objectToFormData(steelBarFormOfficialDto, formdata, "");

        console.log(formdata);
        return await api.post(`/Form/PostSteelBarFormOfficial`, formdata);
        
    }

    const handleSubmit = (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        
        var errorMsg = "";

        errorMsg = SignatureValid.checkSignature(imgData, errorMsg, true);

        console.log(steelBarFormOfficial);
        if (submitting) 
            return;

        setsubmitting(true);
        

        if (form.checkValidity() === false) {
        setsubmitting(false);

        toast.error("Please fill all required fields 請填寫所有必填欄位", {
            className: "custom-toast",
        });
        
        setValidated(true);
        }
        else if(errorMsg !== "")
        {
            //toast.error(errorMsg)
            alert(errorMsg);
            setsubmitting(false);
        }
        else
        {

            handleDataUpload().then((response)=>{
                if (response.status !== 200){
                    alert("Fail to submit. \n 提交失敗。")
                    setsubmitting(false);
                }else{
                    navigate("/form/list")
                }
            }).catch((e)=>{
                console.log(e)
                alert("Fail to submit. \n 提交失敗。" )
                setsubmitting(false);
            })
        }
        
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [width, height] = useDeviceSize()
    const[key, setKey] = useState("Part I")

    const handleTabClick = (tabKey: any, event: any) => {
    if (tabKey === 'submit') {
    event.preventDefault();
    event.stopPropagation();
    if(submitButtonRef.current !== null){
      submitButtonRef.current.click();
    }
    } else {
        setKey(tabKey);
    }
  };

    return (
      <Container className="justify-content-md-center" style={{maxWidth:"1920px"}}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
        {width >= 550 && 
        <Row style={{maxWidth:"550px", maxHeight:"360px"}}>
            <Col><Image style={{maxWidth:"250px", maxHeight:"180px", width:"50vw"}} src={castcoTitleIcon}/></Col><Col style={{width:"50vw", maxWidth:"300px", maxHeight:"180px", lineHeight:"12px", fontSize:"16px", marginTop:"26px"}}><p><b>佳力高試驗中心有限公司</b></p><p><b>CASTCO TESTING CENTRE LTD.</b></p></Col>
        </Row>}
        {width < 550 && 
        <Row style={{maxWidth:"550px", maxHeight:"360px"}}>
            <Image style={{maxWidth:"250px", maxHeight:"180px"}} src={castcoTitleIcon}/>
            <Row style={{maxWidth:"300px", maxHeight:"180px", lineHeight:"1px", fontSize:"18px", fontWeight:"bolder"}}>
                <p><b>佳力高試驗中心有限公司</b></p>
            </Row>
            <Row style={{maxWidth:"300px", maxHeight:"180px", lineHeight:"1px", fontSize:"14px", fontWeight:"bolder"}}>
                <p><b>CASTCO TESTING CENTRE LTD.</b></p>
            </Row>
        </Row>}
        <Row className="p-5">
            <h4 className="text-center"><u><b>Testing of Carbon Steel Reinforcing Bars & Stainless Steel Bars</b></u></h4>
            <h4 className="text-center"><u><b>碳素鋼筋、不銹鋼筋測試</b></u></h4>
        </Row>
        <Col style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button variant="primary" type="submit" disabled={submitting} className="mb-3" style={{ display: 'none' }} ref={submitButtonRef}>
                    Save
        </Button>
        </Col>
        <div className="" style={{width:"inherit"}}>
            <Tabs defaultActiveKey="Part I" id="uncontrolled-tab-example" activeKey={key} className="profile-tabs text-light p-3 fw-bold fs-4 bg-success bg-opacity-75" onSelect={handleTabClick}>
                <Tab eventKey="Part I" title="Contract" tabClassName="profile-tabitem"> 
                    <div className="profile-tab-space">
                        <Row className="bg-success bg-opacity-10 pt-3 m-0">
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridContractNo" xs={12} lg={4}>
                                <Form.Label>Contract No. 合約編號 :</Form.Label>
                                <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["contractNum"] : ""}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCustomerRefNo" xs={12} lg={4}>
                                <Form.Label>Customer Ref. No. 客戶參考編號 :</Form.Label>
                                <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["customerRef"] : ""}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridCustomer" xs={12} lg={4}>
                                    <Form.Label>Customer 客戶名稱 :</Form.Label>
                                    <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["customer"] : ""}/>
                                </Form.Group>
                            </Row>



                            <Row className="mb-3">
                                <Form.Group as={Col} className="mb-3" controlId="formGridProject" xs={12} lg={6}>
                                    <Form.Label>Project 項目名稱 :</Form.Label>
                                    <Form.Control  as="textarea" rows={3} readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["project"] : ""}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridDateDeliveredToSite" xs={12} lg={2}>
                                <Form.Label>Date Delivered to Site 到達工地日期 :</Form.Label>
                                <Form.Control type="date" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["dateDeliveredToSite"] !== null ? SteelBarForm["dateDeliveredToSite"].toString().substring(0, 10) : "" : ""}/>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridSupplier"  xs={12} lg={4}>
                                <Form.Label>Supplier 供應商 :</Form.Label>
                                <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["supplier"] : ""}/>
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" id="formGridCheckboxTesting">
                                <Form.Label>Please carry out Testing is in accordance with 請根據測試標準</Form.Label>
                                <br></br>
                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] === "CS2 : 2012" && 
                                <Form.Check inline type="radio" name="radiogroup" label="CS2 : 2012" disabled checked/>}
                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] !== "CS2 : 2012" && 
                                <Form.Check inline type="radio" name="radiogroup" label="CS2 : 2012" disabled/>}
                                
                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] === "BS 4449 : 2005" && 
                                <Form.Check inline type="radio" name="radiogroup" label="BS 4449 : 2005" disabled checked/>}
                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] !== "BS 4449 : 2005" && 
                                <Form.Check inline type="radio" name="radiogroup" label="BS 4449 : 2005" disabled/>}

                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] === "BS 6744 : 2001" && 
                                <Form.Check inline type="radio" name="radiogroup" label="BS 6744 : 2001" disabled checked/>}
                                {SteelBarForm !== undefined && SteelBarForm["testMethod"] !== "BS 6744 : 2001" && 
                                <Form.Check inline type="radio" name="radiogroup" label="BS 6744 : 2001" disabled/>}

                                {SteelBarForm !== undefined && SteelBarForm["testMethodOther"] !== null && 
                                <Form.Check inline label="Other" disabled checked/>}
                                {SteelBarForm !== undefined && (SteelBarForm["testMethodOther"] === null)  && 
                                <Form.Check inline label="Other" disabled/>}
                                {SteelBarForm !== undefined && SteelBarForm["testMethodOther"] !== null  && 
                                    <>
                                    <Form.Control style={{ display: 'inline-block', width: 'auto' }} readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["testMethodOther"] : ""}/>
                                    </>}
                            </Form.Group>
                            <Form.Group as={Col} controlId = {`formFileStockistCert 1`} xs={12} md={12} lg={12}>
                                <Form.Label>Stockist Cert 供應商證書 :</Form.Label><br></br>
                                {SrcStockistCert.length >= 1 && SrcStockistCert[0] !== "" ?
                                <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcStockistCert[0] + SrcStockistCertType[0]} href={SrcStockistCert[0]}> Stockist Cert Link</a>
                                : <p>Empty</p>}
                            </Form.Group>
                        </Row>
                    </div>
                </Tab>
                <Tab eventKey="Part II" title="Specimens" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        
                        {SteelBarForm !== undefined && SteelBarForm["specimen"] !== undefined && SteelBarForm["specimen"].map((item: any, index: any)=><React.Fragment key={`formGridSpecimens ${index + 2}`}>
                            <Container className="justify-content-md-center" style={{width: "95%"}}>
                                <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                                    Set NO {index + 1}
                                </Row>
                                <Row className="bg-success bg-opacity-10 pt-3">
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId = {`formGridBatchNo ${index + 1}`} xs={12} md={6} lg={3}>
                                            <Form.Label>Batch No. 批號 :</Form.Label>
                                            <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["batchNum"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridmassInBatch ${index + 1}`} xs={12} md={6} lg={3}>
                                            <Form.Label>Mass in Batch 批料重量 (tonne) :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["massInBatch"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridnominalSize ${index + 1}`} xs={12} md={6} lg={3}>
                                            <Form.Label>Nominal Size 鋼筋直徑 (mm) :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["nominalSize"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridgrade ${index + 1}`} xs={12} md={6} lg={3}>
                                            <Form.Label>Grade 等級 :</Form.Label>
                                            <Form.Control  readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["grade"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridbarPattern ${index + 1}`} xs={12} md={12} lg={4}>
                                            <Form.Label>Bar Pattern 鋼筋圖案 :</Form.Label>
                                            <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["barPattern"] : ""}/>
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} controlId={`formGridcustomerSampleIdentityNO ${index + 1}`} xs={12} md={12} lg={4}>
                                            <Form.Label>Customer Sample Identity No. 客戶樣本編號 :</Form.Label>
                                            <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["customerSampleId"] : ""}/>
                                        </Form.Group>

                                        {SteelBarForm !== undefined && SteelBarForm["testMethod"] === "CS2 : 2012" &&
                                        <>
                                        <Form.Group as={Col} controlId={`formGridclass ${index + 1}`} xs={12} md={12} lg={4}>
                                            <Form.Label className="col-form-label col-form-label-sm">Class <br></br> 類型 :</Form.Label>
                                            <Form.Select defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["class"] === "Class 1" ? "Class 1" : "Class 2" : ""} disabled>
                                            <option value="Class 1">Class 1</option>
                                            <option value="Class 2">Class 2</option>
                                            </Form.Select>
                                        </Form.Group>
                                        </>}
                                    </Row>

                                    <Row className="mb-3">

                                    <Form.Group as={Row} className="mt-3">
                                        <Form.Label className="fs-5"><b>No. of Test Specimen 測試數量 (see note) :</b></Form.Label>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenTensile ${index + 1}`} xs={12} lg={3}>
                                            <Form.Label>Tensile (Included mass per meter) 拉伸性能 :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["tensile"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBendPerformance ${index + 1}`} xs={12} lg={3}>
                                            <Form.Label>Bend Performance 彎曲表現 :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["bendPerformance"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenBondProperty ${index + 1}`} xs={12} lg={3}>
                                            <Form.Label>Bond Property (Surface Geometry) 粘結性能 :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["bondPorperty"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId={`formGridnumberOfTestSpecimenChemicalComposition ${index + 1}`} xs={12} lg={3}>
                                            <Form.Label>Chemical Composition 化學分析 :</Form.Label>
                                            <Form.Control type="number" readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["specimen"][index]["chemicalComposition"] : ""}/>
                                        </Form.Group>
                                    </Form.Group>
                                        <p style={{fontSize:"12px", marginTop:"3rem"}}><b>Note : Please refer to table 10 of CS2 : 2012 for the no. of test specimen relevant to the tonnage in the batch</b></p>
                                
                                </Row>

                                </Row>
                            </Container></React.Fragment>)}
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part III" title="Service" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Express Testing Service 快速測試服務* :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxExpress">
                            <Form.Label>Request test service for <span className="text-danger">Express</span> / <span className="text-danger">Double Express</span> 要求 
                            <span className="text-danger"> 快速</span> / <span className="text-danger">特快</span> 測試服務</Form.Label>
                            {/* <br></br><Form.Label>Additional charge 額外收費 <span className="text-danger">30%</span> / <span className="text-danger">50%</span></Form.Label> */}
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["expressTestService"] !== 0 && SteelBarForm["expressTestService"] !== null && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="Yes 是" disabled checked/>}
                            {SteelBarForm !== undefined && (SteelBarForm["expressTestService"] === 0 || SteelBarForm["expressTestService"] === null) && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="Yes 是" disabled/>}

                            {SteelBarForm !== undefined && SteelBarForm["expressTestService"] === 0 && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="No 否" disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["expressTestService"] !== 0 && 
                            <Form.Check inline type="radio" name="radiogroupexpress" label="No 否" disabled/>}

                            {SteelBarForm !== undefined && SteelBarForm["expressTestService"] !== 0 && SteelBarForm["expressTestService"] !== null &&
                            <>
                            <div className="mb-3"></div>
                            <Form.Select style={{ width: "18em"}} defaultValue={SteelBarForm !== undefined ? SteelBarForm["expressTestService"] === 1 ? "30%" : "50%" : ""} disabled>
                              <option value="30%">Express (+30%)</option>
                              <option value="50%">Double Express (+50%)</option>
                            </Form.Select>
                            </>}
                        <br></br>
                        {/* <p style={{fontSize:"12px", marginTop:"1rem"}}><b>* - 30% or 50% Express test service charge depend on laboratory and customer completion date of agreement. </b></p>
                        <p style={{fontSize:"12px"}}><b>* - 30% 或 50% 快速測試服務費用取決於實驗室與客戶協議測試完成日期。</b></p> */}
                        <p style={{fontSize:"12px", marginTop:"1rem"}}><b>* - Express test service charge depend on laboratory and customer completion date of agreement. </b></p>
                        <p style={{fontSize:"12px"}}><b>* - 快速測試服務費用取決於實驗室與客戶協議測試完成日期。</b></p>
                        </Form.Group>

                        {(!admin) && <><Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Laboratory feedback 實驗室回覆 :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxSteel">
                            <Form.Label>Steel Laboratory  (Physical Test)</Form.Label>
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["steeL_LABORATORY_FEEDBACK"] === "Accepted 接受" && 
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Accepted 接受"  disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["steeL_LABORATORY_FEEDBACK"] !== "Accepted 接受" && 
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Accepted 接受"  disabled/>}

                            {SteelBarForm !== undefined && SteelBarForm["steeL_LABORATORY_FEEDBACK"] === "Rejected 否決" && 
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Rejected 否決" disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["steeL_LABORATORY_FEEDBACK"] !== "Rejected 否決" && 
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Rejected 否決" disabled/>}
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                {SrcSignSteel && <img width={"250px"} alt="N/A" src={`data:;base64,${SrcSignSteel}`}/>}
                                {!SrcSignSteel && <p style={{color:"red"}}>To be Confirm</p>}
                            </div>
                        </Form.Group>
                        <br></br>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxChemistry">
                            <Form.Label>Chemistry Laboratory  (Chemical Test)</Form.Label>
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["chemistrY_LABORATORY_FEEDBACK"] === "Accepted 接受" && 
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Accepted 接受"  disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["chemistrY_LABORATORY_FEEDBACK"] !== "Accepted 接受" && 
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Accepted 接受"  disabled/>}

                            {SteelBarForm !== undefined && SteelBarForm["chemistrY_LABORATORY_FEEDBACK"] === "Rejected 否決" && 
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Rejected 否決" disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["chemistrY_LABORATORY_FEEDBACK"] !== "Rejected 否決" && 
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Rejected 否決" disabled/>}
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                {SrcSignChemistry && <img width={"250px"} alt="N/A" src={`data:;base64,${SrcSignChemistry}`}/>}
                                {!SrcSignChemistry && <p style={{color:"red"}}>To be Confirm</p>}
                            </div>
                        </Form.Group> </>}

                        {admin && <><Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Laboratory feedback 實驗室回覆 :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxSteel">
                            <Form.Label>Steel Laboratory  (Physical Test)</Form.Label>
                            <br></br>
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Accepted 接受" required
                            onChange={e => setSteelBarFormData({ ...steelBarFormData, steelLaboratoryFeedback: "Accepted 接受"})}/>
                            <Form.Check inline type="radio" name="radiogroupsteel" label="Rejected 否決" required
                            onChange={e => setSteelBarFormData({ ...steelBarFormData, steelLaboratoryFeedback: "Rejected 否決"})}/>
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                <ImgUploadBox boxLabelEng="Upload signature photo or sign in box" boxLabelChin="上載簽名相片" dataAttribute="Steel" imgData={imgData} setImg={setImg}/>
                                <div style={{display:"flex", flexDirection:"column", width:"180px", borderStyle:"solid", borderWidth:"1px"}}>
                                    {imgData.signatureSteel ? imgData.SignatureDocTypeSteel?.includes("pdf") ? <embed src={SrcSignatureSteel}/> : <img width={"inherit"} alt="preview" src={SrcSignatureSteel} /> : <></> }
                                    
                                </div>
                            </div>
                        </Form.Group>
                        <br></br>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxChemistry">
                            <Form.Label>Chemistry Laboratory  (Chemical Test)</Form.Label>
                            <br></br>
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Accepted 接受" required
                            onChange={e => setSteelBarFormData({ ...steelBarFormData, chemistryLaboratoryFeedback: "Accepted 接受"})}/>
                            <Form.Check inline type="radio" name="radiogroupchemistry" label="Rejected 否決" required
                            onChange={e => setSteelBarFormData({ ...steelBarFormData, chemistryLaboratoryFeedback: "Rejected 否決"})}/>
                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Lab. Sign. 簽署</Form.Label>
                                <ImgUploadBox boxLabelEng="Upload signature photo or sign in box" boxLabelChin="上載簽名相片" dataAttribute="Chemistry" imgData={imgData} setImg={setImg}/>
                                <div style={{display:"flex", flexDirection:"column", width:"180px", borderStyle:"solid", borderWidth:"1px"}}>
                                    {imgData.signatureChemistry ? imgData.SignatureDocTypeChemistry?.includes("pdf") ? <embed src={SrcSignatureChemistry}/> : <img width={"inherit"} alt="preview" src={SrcSignatureChemistry} /> : <></> }
                                    
                                </div>
                            </div>
                        </Form.Group></>}
                    </Row>
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        <Row className="mb-3">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Remark :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxConformity">
                            
                        <Form.Label style={{marginTop:"1rem"}}><b>If you request a statement of conformity to a specification or standard for the test report, Castco's decision rule will be applied. (If no selection of above, laboratory will apply no.2 or 3.)
                                                                        Detail please refer the "Castco Decision rules for statement of conformity on the test report" section of the quotation.
                                                                        </b></Form.Label>
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["statement"] === 0 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)"  disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["statement"] !== 0 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)"  disabled/>}
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["statement"] === 1 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)"  disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["statement"] !== 1 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)"  disabled/>}
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["statement"] === 2 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="3. Statement of conformity not require."  disabled checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["statement"] !== 2 && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="3. Statement of conformity not require."  disabled/>}
                            <br></br>
                        </Form.Group>
                        </Row>

                    </Row>
                </div>
                </Tab>
                {/* <Tab eventKey="Part IV" title="Part IV" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        <Row className="mb-3">
                        <Form.Group as={Row} className="mt-3">
                            <Form.Label className="fs-5"><b>Remark :</b></Form.Label>
                        </Form.Group>
                        <Form.Group className="border border-3 border-dark mb-5" id="formGridCheckboxConformity">
                            
                        <Form.Label style={{marginTop:"1rem"}}><b>If you request a statement of conformity to a specification or standard for the test report, Castco's decision rule will be applied. (If no selection of above, laboratory will apply no.2 or 3.)
                                                                        Detail please refer the "Castco Decision rules for statement of conformity on the test report" section of the quotation.
                                                                        </b></Form.Label>
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] === "1" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)"  readOnly checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] !== "1" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="1. Statement of conformity requested (Decision rules selected in quotation)"  readOnly/>}
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] === "2" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)"  readOnly checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] !== "2" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="2. Statement of conformity requested (Decision rules selected in laboratory)"  readOnly/>}
                            <br></br>
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] === "3" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="3. Statement of conformity not require."  readOnly checked/>}
                            {SteelBarForm !== undefined && SteelBarForm["conformity"] !== "3" && 
                            <Form.Check inline type="radio" name="radiogroupconformity" label="3. Statement of conformity not require."  readOnly/>}
                            <br></br>
                        </Form.Group>
                        </Row>

                    </Row>
                </div>
                </Tab> */}
                <Tab eventKey="Part IV" title="Contact" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        <Row className="mb-3">
                        <Form.Label><b>如有問題 ，</b></Form.Label>
                            <Form.Group as={Col} controlId="formGridContactPerson" xs={12} lg={4}>
                            <Form.Label>請聯絡 Contact :</Form.Label>
                            <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["contact"] : ""}/>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridTelNO" xs={12} lg={4}>
                            <Form.Label>電話號碼 Tel No. :</Form.Label>
                            <Form.Control type="number" readOnly value={SteelBarForm !== undefined ? SteelBarForm["telNum"] : null}/>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridFaxNO" xs={12} lg={4}>
                            <Form.Label>傳真號碼 Fax No. :</Form.Label>
                            <Form.Control type="number" readOnly value={SteelBarForm !== undefined ? SteelBarForm["faxNum"] : null}/>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} className="mb-3" controlId="formGridEmail" xs={12} lg={6}>
                                <Form.Label>測試結果發送至 電郵地址 Send the test results to : E-Mail :</Form.Label>
                                <Form.Control type="email" readOnly value={SteelBarForm !== undefined ? SteelBarForm["email"] : null}/>
                            </Form.Group>

                            <Form.Group as={Col} className="mb-3" controlId="formGridSendTo" xs={12} lg={6}>
                                <Form.Label>測試報告交予 Send the test report to :</Form.Label>
                                <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["reportTo"] : ""}/>
                            </Form.Group>
                            
                            <Form.Group as={Col} className="mb-3" controlId="formGridSendTo" xs={12} lg={4}>
                                <Form.Label><b>測試費用賬單交予 Bill the testing fees to :</b></Form.Label>
                                <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["billTo"] : ""}/>
                            </Form.Group>
                        </Row>
                        <Form.Group>
                            {<Form.Group controlId="formFileChop" className="mb-3">
                                <Form.Label>Company Chop 公司蓋印</Form.Label><br></br>
                                {type==="pdf" &&
                                <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} href={SrcChop}> Chop Link</a>}
                                {type==="image" &&
                                <img width={"250px"} alt="N/A" src={`data:image/jpg;base64,${SrcChop}`}/>}
                            </Form.Group>}

                            <div style={{display:"flex", flexDirection:"column", justifyContent:"left"}}>
                            <Form.Label>Customer's Signature 客戶代表簽署</Form.Label>
                                <img width={"250px"} alt="N/A" src={`data:image/jpg;base64,${SrcSign}`}/>
                            </div>
                        </Form.Group>
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part V" title="Report" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                        {SteelBarForm !== undefined && SteelBarForm["additionInfo"] !== undefined && SteelBarForm["additionInfo"].map((item: any, index: any)=><React.Fragment key={`formGridtestReport ${index + 2}`}>
                        {/* {TR !== undefined && TR["deliverY_NOTE_NO"].map((item: any, index: any)=><> */}
                            <Container className="justify-content-md-center" style={{width: "95%"}}>
                                <Row className="text-light  bg-success bg-opacity-75 p-1 fw-bold fs-5">
                                    Set NO {index + 1}
                                </Row>
                                <Row className="bg-success bg-opacity-10 pt-3">
                                    <Row className="mb-3">
                                    <Form.Label><b>If need to show the information in the test report, please fill in the details</b></Form.Label>
                                        <Form.Group as={Col} controlId = {`formGridDeliveryNoteNO ${index + 1}`} xs={12} md={6} lg={2}>
                                            <Form.Label>Delivery Note No. 交貨單號 :</Form.Label>
                                            <Form.Control readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["additionInfo"][index]["deliveryNoteNum"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId = {`formGridStockistCertNO ${index + 1}`} xs={12} md={6} lg={2}>
                                            <Form.Label>Stockist Cert No. 供應商證書編號 :</Form.Label>
                                            <Form.Control  readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["additionInfo"][index]["stockistCertNum"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId = {`formGridLotNO ${index + 1}`} xs={12} md={6} lg={2}>
                                            <Form.Label>Lot No. 批號 :</Form.Label>
                                            <Form.Control  readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["additionInfo"][index]["lotNum"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId = {`formGridMillCertNO ${index + 1}`} xs={12} md={6} lg={2}>
                                            <Form.Label>Mill Cert No. 工廠證書編號 :</Form.Label>
                                            <Form.Control  readOnly as="textarea" rows={2} defaultValue={SteelBarForm !== undefined ? SteelBarForm["additionInfo"][index]["millCertNum"] : ""}/>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId = {`formGridHeatNO ${index + 1}`} xs={12} md={12} lg={4}>
                                            <Form.Label>Heat No. 爐編號 :</Form.Label>
                                            <Form.Control  readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["additionInfo"][index]["heatNum"] : ""}/>
                                        </Form.Group>

                                        <div className="mb-3"></div>

                                        {/* <Form.Group as={Col} controlId = {`formFileStockistCert ${index + 1}`} xs={12} md={12} lg={3}>
                                            <Form.Label>Stockist Cert 供應商證書 :</Form.Label><br></br>
                                            {SrcStockistCert.length >= index + 1 && SrcStockistCert[index] !== "" ?
                                            <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcStockistCert[index] + SrcStockistCertType[index]} href={SrcStockistCert[index]}> Stockist Cert Link</a>
                                            : <p>Empty</p>}
                                        </Form.Group>

                                        <Form.Group as={Col} controlId = {`formFileMillCert ${index + 1}`} xs={12} md={12} lg={3}>
                                            <Form.Label>Mill Cert 工廠證書 :</Form.Label><br></br>
                                            {SrcMillCert.length >= index + 1 && SrcMillCert[index] !== ""?
                                            <a rel="noreferrer noopener" target="_blank" style={{ width: 'auto' }} download={SrcMillCert[index] + SrcMillCertType[index]} href={SrcMillCert[index]}> Mill Cert Link</a>
                                            : <p>Empty</p>}
                                        </Form.Group> */}
                                    </Row>

                                </Row>
                            </Container></React.Fragment>)}
                    </Row>
                </div>
                </Tab>
                <Tab eventKey="Part VI" title="Remark" tabClassName="profile-tabitem">
                    <div className="profile-tab-space">
                        <Row className="bg-success bg-opacity-10 pt-3 m-0">
                            <Row className="mb-3">
                                <Form.Group as={Col} className="mb-3" controlId="formGridRemark"  xs={12} lg={12}>
                                    <Form.Label>Remark 備註 :</Form.Label>
                                    <Form.Control  as="textarea" rows={3} 
                                    readOnly defaultValue={SteelBarForm !== undefined ? SteelBarForm["remark"] !== "undefined" ? SteelBarForm["remark"] : "" : ""}/>
                                </Form.Group>
                            </Row>
                        </Row>
                    </div>
                </Tab>
                {admin && <Tab eventKey="Official" title="Official" tabClassName="profile-tabitem">
                <div className="profile-tab-space">
                    <Row className="bg-success bg-opacity-10 pt-3 m-0">
                    <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridMethod" xs={12} lg={3}>
                            <Form.Label>Method :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["method"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Method: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridCapability" xs={12} lg={3}>
                            <Form.Label>Capability :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["capability"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Capability: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridResources" xs={12} lg={3}>
                            <Form.Label>Resources :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["resources"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Resources: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridCompletionDate" xs={12} lg={3}>
                            <Form.Label>Completion Date :</Form.Label>
                            <Form.Control required  type="date" defaultValue={Official !== undefined ? Official["completioN_DATE"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, CompletionDate: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridSubcontracting" xs={12} lg={3}>
                            <Form.Label>Subcontracting not requested? </Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["subcontracting"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Subcontracting: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridConflictOfInterest" xs={12} lg={3}>
                            <Form.Label>Conflict of interest :</Form.Label>
                            <br></br>
                            {Official !== undefined && Official["conflicT_OF_INTEREST"] === true &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="Yes" required checked
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: true})}/>}
                            {Official !== undefined && Official["conflicT_OF_INTEREST"] !== true &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="Yes" required
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: true})}/>}
                            {Official === undefined &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="Yes" required
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: true})}/>}

                            {Official !== undefined && Official["conflicT_OF_INTEREST"] === false &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="No" checked
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: false})}/>}
                            {Official !== undefined && Official["conflicT_OF_INTEREST"] !== false &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="No"
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: false})}/>}
                            {Official === undefined &&
                            <Form.Check inline type="radio" name="radiogroupConflictOfInterest" label="No"
                            onClick={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, ConflictOfInterest: false})}/>}
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridAcceptedBy" xs={12} lg={3}>
                            <Form.Label>Accepted by :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["accepted_BY"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, AcceptedBy: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridDate" xs={12} lg={3}>
                            <Form.Label>Date :</Form.Label>
                            <Form.Control required  type="date" defaultValue={Official !== undefined ? Official["date"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Date: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridSampleLocation" xs={12} lg={6}>
                            <Form.Label>Sample Location :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["samplE_LOCATION"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, SampleLocation: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridRemarks" xs={12} lg={6}>
                            <Form.Label>Remarks :</Form.Label>
                            <Form.Control required defaultValue={Official !== undefined ? Official["remarks"] : ""}
                            onChange={e => setSteelBarFormOfficial({ ...steelBarFormOfficial, Remarks: e.target.value})}/>
                            <Form.Control.Feedback type="invalid">
                                Please fill in the column.
                            </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    </Row>
                </div>
                </Tab>}
                {admin && <Tab eventKey="submit" title="Save" tabClassName="profile-tabitem" disabled={submitting}/>}
                {!admin && <Tab title="" disabled></Tab>}
            </Tabs>
        </div>
    </Form>
    <Row className="mt-3 text-light  bg-success bg-opacity-75 p-3 fw-bold fs-3 m-0" style={{height: "25rem"}}>
       <Row className="fs-6">
        <Col xs={12} md={4}>
            Physical Test - <br></br>
            E-mail : steel@castco.com.hk <br></br>
            Attn : Ms. Winky Yiu <br></br>
            Direct Line : 2597 8273 <br></br>
            <br></br>
        </Col>
        <Col xs={12} md={12}>
            <Row>
                <Col xs={18} md={4}>香港新界粉嶺安居街33號</Col>
                <Col xs={18} md={4}>33, On Kui Street, Fanling, Hong Kong </Col>
                <Col xs={18} md={4}>Tel: (852) 2597 8333</Col>
            </Row>
            <br></br>
            <Row>
                <Col xs={18} md={4}>香港粉嶺安全街29A號</Col>
                <Col xs={18} md={4}>29A, On Chuen Street Fanling, Hong Kong</Col>
                <Col xs={18} md={4}>Fax: (852) 2597 8399</Col>
            </Row>
            <br></br>
            <Row>
                <Col xs={18} md={4}>Email: info@castco.com.hk</Col>
                <Col xs={18} md={4}>Website: www.castco.com.hk</Col>
                <Col xs={18} md={4}></Col>
            </Row>
        </Col>
      </Row>
    </Row>
    </Container>
    );
  };
  
  export default SteelBarFormView;
  